import React from "react";
import '../assets/styles/Main.scss';
import '../assets/styles/About.scss';

function About() {

  return (
    <div id="about">
    <div className="">
      <div className="section">
        <div className="content">
          <h1>More About Me</h1>
          <p>
            Sophomore computer science student, taking human computer interaction class, interested in designing and developing technical products for users who are in need. 
            I am a creative and detail-oriented student with a passion for aesthetics eager to gain knowledge & experience in Design Thinking. 
            In the future, I hope to shape the technology I am building from the lens of humans through user interview, accessibility practices, and convenient design.
          </p>
        </div>
      </div>
    </div>
    <hr className="container" />
    </div>
  );
}

export default About;